export default (object: any, property: string) => new Promise((resolve) => {
  if (Object.prototype.hasOwnProperty.call(object, property)) {
    resolve(true);
  } else {
    const interval = setInterval(() => {
      if (Object.prototype.hasOwnProperty.call(object, property)) {
        clearInterval(interval);
        resolve(true);
      }
    }, 300);
  }
});
